import phone from './images/phone-store.PNG';
import logo from './images/Tracker.PNG';
import logo1 from './images/couser.PNG';
import logo2 from './images/Movie-Land.PNG';
import Chat from './images/chat_app.PNG';
import spice from './images/spiceup.PNG';
const all = [
  {
    title: 'Kings_Mobile',
    logo: phone,
    description:
      'Shop top-tier electronics at KINGS_MOBILE. Browse, buy, and enjoy!',
    skills: ['Next.js', 'Prisma', 'Stripe'],
    demo: 'https://kings-mobile-store.vercel.app/',
    repo: 'https://github.com/okoid721',
  },
  {
    title: 'Easy text',
    logo: Chat,
    description:
      'Connect effortlessly with Easy Text. Experience seamless communication, instant messaging, and endless conversations. Join the conversation now',
    skills: ['react', 'expess', 'node'],
    demo: 'https://chat-full-project.onrender.com/',
    repo: 'https://github.com/okoid721',
  },
  {
    title: 'couser',
    logo: logo1,
    description: 'This is Just A landing page of a course website',
    skills: ['react', 'expess', 'node'],
    demo: 'https://online-course-neon.vercel.app/',
    repo: 'https://github.com/okoid721',
  },
  {
    title: 'King Movie Land',
    logo: logo2,
    description:
      'Explore the vast world of cinema with MovieLand. Discover your favorite movies, explore new releases, and find hidden gems. Start your cinematic journey now!',
    skills: ['React', 'API Integration', 'Responsive Design'],
    demo: 'https://online-course-neon.vercel.app/',
    repo: 'https://github.com/okoid721',
  },
  {
    title: 'ExpenseTracker',
    logo: logo,
    description:
      'Keep your finances in check with ExpenseTracker. Easily track your expenses, manage your budget, and stay on top of your financial goals. Take control of your spending habits today!',
    skills: ['React', 'Node.js', 'MongoDB'],
    demo: 'https://tracker-frontend-om62.vercel.app/',
    repo: 'https://github.com/okoid721',
  },
  {
    title: 'SPICE_UP',
    logo: spice,
    description:
      'Explore a world of culinary delights with Spice_up. Discover thousands of mouth-watering recipes from around the globe, ranging from quick and easy meals to gourmet dishes. Get inspired, cook with confidence, and delight your taste buds!',
    skills: ['React', 'Node.js', 'MongoDB'],
    demo: 'https://spice-up.vercel.app/',
    repo: 'https://github.com/okoid721',
  },
];

export default all;
